import { render } from "./RailIconRight.vue?vue&type=template&id=7004b6ad&scoped=true"
const script = {}

import "./RailIconRight.vue?vue&type=style&index=0&id=7004b6ad&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7004b6ad"]])

export default __exports__